import bm from "../images/bm.png";
import arudu_cargo from "../images/arudu-cargo.png";
import directo from "../images/directo.png";
import directo2 from "../images/directo-02.png";
import dreamroutes from "../images/dreamroutes.png";
import moneyboon from "../images/moneyboon.png";
import finenets from "../images/finenets.png";
import ematasata from "../images/ematasata.png";
import arudu from "../images/arudu.png";
import foodlist from "../images/foodlist.png";

const projects = [
  {
    id: "3",
    title: "Arudu Cargo App",
    tagline: "Creating and Delivery Articles / Adding Inventory / Booking Stock",
    repository: "private",
    live: true,
    category: "featured",
    liveUrl: "https://play.google.com/store/apps/details?id=com.arudu.app",
    videoUrl: "https://youtu.be/Md50HSm-6mU",
    img: arudu_cargo,
  },

  {
    id: "4",
    title: "Moneyboon App",
    tagline: "Buy and Sell Stocks",
    repository: "private",
    live: false,
    category: "featured",
    // videoUrl: "https://youtube.com/shorts/wvhRRr3ag8I?feature=share",
    img: moneyboon
  },

  // {
  //   id: "4",
  //   title: "Directo App",
  //   tagline: "The First Web3 Freelance Marketplace",
  //   repository: "private",
  //   live: false,
  //   category: "featured",
  //   //  videoUrl: "https://www.youtube.com/watch?v=xqAiHvl_VWA",
  //   img: directo2
  // },

  {
    id: "1",
    title: "B.M Restaurant App",
    tagline: "Food Ordering and Order Tracking",
    repository: "public",
    live: false,
    category: "featured",
    repositoryUrl: "https://github.com/Noor-e-Iqra/Bismillah-Restaurant-App-React-Native",
    videoUrl: "https://youtu.be/8pqlbrIORtw",
    img: bm,
  },

  {
    id: "2",
    title: "E-MataSata App",
    tagline: "Exchanging, Selling and Donating, Skills and Educational accessories",
    repository: "private",
    live: false,
    category: "featured",
    videoUrl: "https://youtu.be/dtfL0-98G0c",
    img: ematasata,
  },

  {
    id: "5",
    title: "Moneyboon App",
    tagline: "Buy and Sell Stocks",
    repository: "private",
    live: false,
    category: "frontend",
    // videoUrl: "https://youtube.com/shorts/wvhRRr3ag8I?feature=share",
    img: moneyboon
  },

  {
    id: "6",
    title: "Dreamroutes App",
    tagline: "List the world's most beautiful, adventurous roads on Google Map",
    repository: "private",
    live: false,
    category: "frontend",
    // videoUrl: "https://youtu.be/W3B9LwA7ttU",
    img: dreamroutes,
  },

  {
    id: "7",
    title: "Arudu App",
    tagline: "Ecommerce / Regional shops",
    repository: "private",
    live: false,
    category: "frontend",
    //  videoUrl: "https://www.youtube.com/shorts/tQiKGEY-YCQ",
    img: arudu
  },

  {
    id: "8",
    title: "Foodintab App",
    tagline: "Food Ordering from Different Restaurants",
    repository: "private",
    live: false,
    category: "frontend",
    videoUrl: "https://youtu.be/9WyEoQ31pMY",
    img: foodlist
  },

  {
    id: "9",
    title: "Finenets App",
    tagline: "Ecommerce / Social Community / Blogs / Forums / Ratings",
    repository: "private",
    live: false,
    category: "frontend",
    videoUrl: "https://youtu.be/kTtu6mP2i18",
    img: finenets
  },
  // {
  //   id: "10",
  //   title: "Directo App",
  //   tagline: "The First Web3 Freelance Marketplace",
  //   repository: "private",
  //   live: false,
  //   category: "web3",
  //   //  videoUrl: "https://youtu.be/xqAiHvl_VWA",
  //   img: directo2
  // },
]

export default projects
